module.exports = __webpack_public_path__ + "84f428cf59662cb21f0e0e81ba64c1c2.jpg";